const Button = (params) => {
    return (
        <button type={params.type ?? 'button'} className={params.className ?? "btn-greengg"}>{params.text}</button>
    );
}

export default Button;